import {DebugLevelPicker} from "./DebugLevelPicker";
import {DebugPanelNotifications} from "@game/ui/debug/DebugPanelNotifications";

export const DebugPanel = () => (
    <span
        id="debug-panel"
        style={{
            zIndex: 10,
            pointerEvents: "all",
            position: "absolute",
            left: "50%",
            bottom: "90px"
        }}
    >
        <DebugPanelNotifications />
        <DebugLevelPicker />
    </span>
);
